module.exports = __webpack_public_path__ + "static/media/service2.55a1907a.png";